/**
 * Detect whether a stream URL is DASH (.mpd) or HLS (.m3u8/.m3u).
 */

export type StreamType = 'dash' | 'hls';

export function getStreamType(url: string): StreamType {
  try {
    const pathname = new URL(url).pathname.toLowerCase();
    if (pathname.endsWith('.mpd')) return 'dash';
  } catch {
    // Not a valid URL — fall through to HLS default
  }
  return 'hls';
}

export function isDashUrl(url: string): boolean {
  return getStreamType(url) === 'dash';
}
